import {
  MOMENTUM,
  barHeights,
  paceKind,
  pctCss,
  usualAt,
  type MomentumScenario,
} from '../momentum';
import { $, $$, radiogroup, text } from './dom';
import { track } from './events';

/* -------------------------------------------------------------------------
 * The Momentum section: three changes of pace as radios, and the chart, the
 * progress track and the email that follow the one checked. The server drew
 * the first; this repaints the same elements, so the bars, the usual-pace
 * line and the track move to the new figures (over .45s in the stylesheet,
 * which drops the move under reduced motion).
 * ---------------------------------------------------------------------- */

/** Each [data-mo] element's text, by its value, in one scenario. */
export function momentumFields(s: MomentumScenario): Record<string, string> {
  const fields: Record<string, string> = {
    summary: s.summary,
    name: s.name,
    meta: s.meta,
    chip: s.chip,
    usualLabel: s.usualLabel,
    callout0: s.callout[0],
    callout1: s.callout[1],
    today: s.today,
    progressLabel: s.progress.label,
    raised: s.progress.raised,
    atPace: s.progress.atPace,
    goalLabel: s.progress.goalLabel,
    goal: s.progress.goal,
    provenance: s.provenance,
    time: s.email.time,
    subject: s.email.subject,
    kicker: s.email.kicker,
    finding: s.email.finding,
    platform: s.email.platform,
  };
  s.email.cells.forEach((cell, i) => {
    fields[`cell${i}Label`] = cell.label;
    fields[`cell${i}`] = cell.value;
  });
  return fields;
}

export function paintMomentum(root: HTMLElement, s: MomentumScenario): void {
  root.dataset.kind = s.key;
  const fields = momentumFields(s);
  for (const el of $$(root, '[data-mo]')) {
    const value = fields[el.dataset.mo ?? ''];
    if (value !== undefined) text(el, value);
  }
  const heights = barHeights(s);
  $$(root, '[data-mo-bar]').forEach((bar, i) =>
    bar.style.setProperty('--h', pctCss(heights[i] ?? 0)),
  );
  $(root, '[data-mo-usual]')?.style.setProperty('--at', pctCss(usualAt(s)));
  const bar = $(root, '[data-mo-track]');
  bar?.style.setProperty('--solid', `${s.progress.solid}%`);
  bar?.style.setProperty('--proj', `${s.progress.projW}%`);
}

export function momentumSection(root: HTMLElement): void {
  const group = $(root, '[role="radiogroup"]');
  if (!group) return;
  radiogroup(group, (value) => {
    const kind = paceKind(value);
    if (!kind) return;
    paintMomentum(root, MOMENTUM[kind]);
    track('landing_momentum_picked', { scenario: kind, from: 'section' });
  });
}
